module.exports = __webpack_public_path__ + "6a51b604178311fd9ddc7c99ba8b2292.jpg";